<script>
    import { _ } from 'svelte-i18n';
    import { navigate } from "svelte-routing";
    import moment from "moment";
    import Button from '../Button.svelte';
    import muscles from '../muscles.json';
    import { selectedMuscleGroups } from './stores/muscleGroupStore';
    import { formValues } from "./stores/formValueStore";
    import { onMount } from "svelte";

    const navigateWithScroll = () => {
		navigate('/');
		document.querySelector('#calculate').scrollIntoView({behavior: "smooth"})
	}

    function fillFormValues() {
        if ($formValues) {
            const form = document.querySelector("#muscle-form")
            for (const [key, value] of Object.entries($formValues)) {
                const input = form.elements[key];
                if (input) {
                    if (input.type === 'checkbox')
                        input.checked = !!value
                    else
                        input.value = value;
                }
            }
        }
    }

    onMount(() => {
        document.querySelector('#calculate').scrollIntoView({behavior: "smooth"})
        fillFormValues()
    })

    const handleChange = (event) => {
        event.preventDefault()
        const formData = new FormData(event.currentTarget)
        const data = []
        for (const [key, value] of Object.entries(Object.fromEntries(formData))) {
            if (event.currentTarget[key].type === 'number') {
                data[key] = parseFloat(value)
            } else {
                data[key] = value
            }
        }
        formValues.set(data)
    }
</script>

<style>

.form-wrapper {
    max-width:600px;
    margin: auto;
}

.value-form {
    margin: var(--spacingXLarge) 0;
}

.input-row {
    margin-bottom: var(--spacingMedium);
    display: flex;
    justify-content: space-between;
    position: relative;
}

.button-row {
    display: flex;
    justify-content: space-between;
    margin-top: var(--spacingLarge);
}

.arrow-right {
    right: 10px;
}

.arrow-left {
    left: 10px;
    transform: rotate(180deg);
}

input {
    padding: var(--spacingSmall);
    width: 300px;
}

input:focus {
    outline: none;
    box-shadow: 0 0 0 5px var(--colorBgVariant);
}

input, span, label {
    color: var(--colorElement);
    font-size: var(--typeSizeMedium);
    text-align: center;
}

span, .input-row > label {
    line-height: 40px;
}

::placeholder {
   color: var(--colorElementOpaque)
}

span.pre-input {
    position: absolute;
    font-size: var(--typeSizeDefault);
    left: -10px;
    bottom: 0;
    transform: translate(-100%, 0);
}

span.post-input {
    position: absolute;
    font-size: var(--typeSizeDefault);
    right: -10px;
    bottom: 0;
    transform: translate(100%, 0);
}

/* Because the pre- and post-input elements are texts and will be of unknown size, the translate props
are to make sure they will be positioned according to the edge closest to the relative element. */

.gender-selection {
    width: 300px;
    display: flex;
    justify-content: space-between;
}

.gender-selection input {
   opacity: 0;
   position: absolute;
}

.gender-selection label {
    color: var(--colorElement);
    background-color: var(--colorBg);
    padding: var(--spacingSmall) var(--spacingMedium);
    border: 2px solid var(--colorElement);
    border-radius: 4px;
    width: 48%;
    cursor: pointer;
}

.gender-selection input:checked + label {
    background-color: var(--colorElement);
    color: var(--colorFgInverse);
}

.chosen-muscle {
    margin-top: var(--spacingXXLarge);
}

.chosen-muscle-title {
    position: relative;
}

.chosen-muscle-image {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    background-color: var(--colorBgVariant);
    position: absolute;
    left: -130px;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    /*padding: var(--spacingXSmall);*/
}

.chosen-muscle-image img {
    max-width: 100%;
}

.chosen-muscle-input-wrap {
    display: flex;
    justify-content: flex-end;
}

.chosen-muscle-input {
    display: flex;
    justify-content: space-between;
    width: 300px;
}

.chosen-muscle-input > div {
    flex-direction: column;
    position: relative;
    width: 140px;
}

.chosen-muscle-input input, .lr-header {
    margin-top: var(--spacingSmall);
    width: 100%;
}

.lr-header {
    text-align: center;
}

@media screen and (max-width: 900px) {
     .chosen-muscle-image {
        left: 0;
        top: 50px;
     }
}

@media screen and (max-width: 560px) {

    input, .gender-selection {
        width: 100%;
    }

    .input-row {
        flex-direction: column;
    }

    .input-row label, .input-row .label {
        text-align: left;
    }

    .button-row {
        flex-direction: column;
        align-items: center;
    }

    .chosen-muscle-title {
        margin-bottom: var(--spacingMedium);
    }

    .chosen-muscle-image {
        position: unset;
    }
}

@media screen and (max-width: 410px) {

    .chosen-muscle-input {
        width: 210px;
    }

    .chosen-muscle-input > div {
        width: 100px;
    }
}

</style>

<form
    class="form-wrapper"
    id="muscle-form"
    on:change={handleChange}
    on:submit={(event) => {
        handleChange(event)
        navigate('/calculator-2')
    }}
>
    <!-- Prevent implicit submission of the form -->
    <button type="submit" disabled style="display: none" aria-hidden="true"></button>

    <h2>{$_('calculator.form.title')}</h2>

    <p>{$_('calculator.form.intro')}</p>

    <hr />
    <div class="value-form">
        <div class="input-row">
            <label for="name" class="label">{$_('calculator.form.name')}:</label>
            <input type="text" name="name" id="name">
        </div>
        <div class="input-row">
            <label for="birthdate" class="label">{$_('calculator.form.birthdate')}:</label>
            <input type="date" name="birthdate" id="birthdate" placeholder={$_('calculator.form.date_placeholder')}>
        </div>
        <div class="input-row">
            <label for="measuredate" class="label">{$_('calculator.form.measure_date')}:</label>
            <input
                type="date"
                name="measuredate"
                id="measuredate"
                placeholder={$_('calculator.form.date_placeholder')}
                value={moment().format('YYYY-MM-DD')}
            >
        </div>
        <div class="input-row">
            <label for="weight" class="label">{$_('calculator.form.weight')}:</label>
            <div class="weight-input-wrap">
                <input
                    type="number"
                    step="0.1"
                    value="0"
                    min="0"
                    name="weight"
                    id="weight"
                    onClick="this.select();"
                >
                <span class="post-input">{$_('calculator.form.kg')}</span>
            </div>
        </div>
        <div class="input-row">
            <span class="label">{$_('calculator.form.gender')}:</span>
            <div class="gender-selection">
                    <input type="radio" name="gender" id="female" value="female" checked>
                    <label for="female">{$_('calculator.form.female')}</label>

                    <input type="radio" name="gender" id="male" value="male">
                    <label for="male">{$_('calculator.form.male')}</label>
            </div>
        </div>
        <div class="input-row">
            <label for="terapeut" class="label">{$_('calculator.form.terapeut')}:</label>
            <input type="text" name="terapeut" id="terapeut">
        </div>

        {#each muscles as muscle}
            {#if $selectedMuscleGroups.includes(muscle.id)}
                <div class="chosen-muscle">
                    <div class="chosen-muscle-title">
                        <span class="label">{$_('calculator.muscles.' + muscle.name)}</span>
                        <div class="chosen-muscle-image"><img alt="{$_('calculator.form.position_alt') + ' ' + $_('calculator.muscles.' + muscle.name)}" src="img/positions_nobg/{muscle.img}" /></div>
                    </div>
                    <!-- This below was originally a single loop,
                        but it had to be rebuilt to get the correct tab order for the fields -->
                    <div class="chosen-muscle-input-wrap">
                        <div class="chosen-muscle-input">
                            <div class="muscle-right-inputs">
                                <div class="lr-header">{$_('calculator.results.right')}</div>
                                {#each [1,2,3] as id}
                                    <input
                                        name="muscle-{muscle.id}-{id}-right"
                                        type="number"
                                        step="0.1"
                                        value="0"
                                        min="0"
                                        onClick="this.select();"
                                    >
                                {/each}
                                <span class="pre-input">{$_('calculator.form.lever')}:</span>
                                <input
                                    type="number"
                                    name="muscle-{muscle.id}-right-lever"
                                    step="0.1"
                                    value="0"
                                    min="0"
                                    onClick="this.select();"
                                >
                            </div>
                            <div class="muscle-left-inputs">
                                <div class="lr-header">{$_('calculator.results.left')}</div>
                                {#each [1,2,3] as id}
                                    <input
                                        name="muscle-{muscle.id}-{id}-left"
                                        type="number"
                                        step="0.1"
                                        value="0"
                                        min="0"
                                        onClick="this.select();"
                                    >
                                {/each}
                                <input
                                    type="number"
                                    name="muscle-{muscle.id}-left-lever"
                                    step="0.1"
                                    value="0"
                                    min="0"
                                    onClick="this.select();"
                                >
                                <span class="post-input">{$_('calculator.form.cm')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
        {/each}
    </div>

    <hr />

    <div class="button-row">
        <Button width=230px backbutton on:click={navigateWithScroll}><span class="arrow arrow-left"></span>{$_('calculator.button_back')}</Button>
        <Button width=230px type="submit">{$_('calculator.button_next')}<span class="arrow arrow-right"></span></Button>
    </div>
</form>
